require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.define-property");

(function (global, factory) {
  if ('function' == typeof define && define.amd) define(['exports'], factory);else if ('undefined' != typeof exports) factory(exports);else {
    var mod = {
      exports: {}
    };
    factory(mod.exports), global.examples = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, '__esModule', {
    value: !0
  }), exports["default"] = function (list) {
    if (list.constructor !== Array) throw new Error('Item passed to .examples is not an array');

    var _iteratorNormalCompletion = !0,
        _didIteratorError = !1,
        _iteratorError = void 0;

    try {
      for (var _step, _iterator = list[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = !0) {
        var item = _step.value,
            usage = item.usage || !1,
            description = item.description || !1;
        this.example(usage, description);
      }
    } catch (err) {
      _didIteratorError = !0, _iteratorError = err;
    } finally {
      try {
        !_iteratorNormalCompletion && _iterator["return"] && _iterator["return"]();
      } finally {
        if (_didIteratorError) throw _iteratorError;
      }
    }

    return this;
  };
});